<template>
  <div>
    <div class="col-md-8">
      <h3>Выберите оператора: </h3>
    </div>
    <div class="col-md-4" v-if="$user.get().role === 'admin'">
      <div class="be-aside-header-search">
        <div class="input-group input-search input-group-sm">
          <input v-model="filterQuery" type="text"
                 placeholder="Быстрый поиск по ИНН, названию, адресу, рег. номеру" class="form-control">
          <span
            class="input-group-btn">
                      <button type="button" class="btn btn-default"><i class="icon mdi mdi-search"></i></button></span>
        </div>
      </div>
    </div>
    <div class="main-content container-fluid">
      <div class="row pricing-tables">
        <div class="col-md-3" v-for="operator in filteredOperators">
          <div class="pricing-table pricing-table-primary">
            <b>Регистрационный №: {{operator.id}}</b>
            <template v-if="$user.get().role === 'admin'"></template>
            <div class="panel-divider panel-divider-xl"></div>
            <router-link :to="{name: 'operator-visits', params: {operatorId: operator.id}}">
              <div class="pricing-table-title">{{operator.name}}</div>
            </router-link>
            <ul class="pricing-table-features" style="margin-bottom: 0px">
              <li>ИНН: {{operator.inn}}</li>
              <li v-if="$user.get().role === 'admin'">{{getUsersEmail(operator.users)}}</li>
            </ul>
            <div class="panel-divider panel-divider-xl"></div>
            <ul class="pricing-table-features" style="margin-bottom: 0px">
              <li>{{operator.address}}</li>
            </ul>
          </div>
        </div>
        <div v-if="filteredOperators.length===0 && filterQuery" class="text-center" style="margin-top: 20px"><h3>
                      Операторы с заднными параметрами поиска не найдены.</h3></div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'

  export default {
    data: function () {
      return {
        activeOperator: null,
        filterQuery: null
      }
    },
    created () {
      if (this.operators.length === 1) {
        this.$router.push({name: 'operatorGuestList', params: {id: this.operators[0].id}})
      }
    },
    computed: {
      ...mapGetters(
        {
          operatorTypes: 'operatorTypes',
          operators: 'operators',
        }
      ),
      filteredOperators () {
        if (this.filterQuery) {
          let query = this.filterQuery.toLowerCase()
          return this.operators.filter(operator => {
            let id = String(operator.id).toLowerCase().includes(query)
            let name = operator.name.toLowerCase().includes(query)
            let inn = operator.inn.toLowerCase().includes(query)
            let address = operator.address ? operator.address.toLowerCase().includes(query) : false
            let city = operator.city ? operator.city.toLowerCase().includes(query) : false
            let type = operator.type ? this.operatorTypes.find(item => Number(item.id) === Number(operator.type)).name.toLowerCase().includes(query) : false
            let email = this.getUsersEmail(operator.users).toLowerCase().includes(query)
            return (name || inn || address || city || type || id || email)
          })
        } else {
          return this.operators
        }
      }
    },
    methods: {
      getUsersEmail (users) {
        let emails = []
        users.forEach(user => (emails.push(user.email)))
        return emails.join('; ')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/operators/OperatorSelect.vue